<div class="form-buscar-texto">
    <input type="text" placeholder="Buscar..." class="input-buscar-texto" [(ngModel)]="valor" />
    <label class="label-buscar-texto">
      <button class="button-buscar-texto" type="button" (click)="enviar()">Buscar</button>
    </label>
</div>